"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconShare = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconShare = function IconShare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.75 4.839h6.531L7.844 6.968H4.04v11.355h15.17v-3.549l2.04-2.27v5.109c0 1.568-1.231 2.839-2.75 2.839H4.75c-1.519 0-2.75-1.271-2.75-2.84V7.678C2 6.11 3.231 4.84 4.75 4.84zM24 7.677l-6.875 5.678v-2.827c-4.582-.17-7.341 1.937-9.67 4.279 0-5.567 4.803-9.952 9.67-10.001V2L24 7.677z"
  }));
};
exports.IconShare = IconShare;